(function($) {
    $(function() {
        $(document).ready(function() {
            if ($('.fellows-team-slider').length > 0) {
                if ($('body .fellows-team-slider.with-top-img .fellow-card-wrapper .fellow-card').length > 2) {
                    $('.fellows-team-slider.with-top-img .fellow-card-wrapper').not('.slick-initialized').slick({
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: true,
                        infinite: false,
                        cssEase: 'linear',
                        responsive: [{
                                breakpoint: 1025,
                                settings: {
                                    slidesToShow: 3
                                }
                            },
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: 2
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1,
                                    draggable: true
                                }
                            }
                        ]
                    });
                }
            }
            if ($('#participants').length > 0) {
                var nid = $('.node_id').val();
                var path = '/json/participant/' + nid + '/';
                $.get(path, function(data) {
                    $.each(data, function(key, value) {
                        var url = value.view_node;
                        var name = value.title;
                        var text = value.field_fellow_position;
                        var output = '<li> <a href="' + url + '" class="link-with-black"><span>' + name + '</span></a></li>';
                        $('.list-with-links.col-three-without-title .links-wrap').append(output);
                    });
                }).done(function(){
                    initFellowSlider();
                });
            }
            if ($('#contributors').length > 0) {
                var nid = $('.node_id').val();
                var path = '/json/contributor/' + nid + '/';
                $.get(path, function(data) {
                    $.each(data, function(key, value) {
                        var url = value.view_node;
                        var name = value.title;
                        var text = value.field_fellow_position;
                        var output = '<li> <a href="' + url + '" class="link-with-black"><span>' + name + '</span></a></li>';
                        $('.list-with-links.col-three-without-title .links-wrap').append(output);
                    });
                }).done(function(){
                    initFellowSlider();
                });
            }
            if ($('#leadership').length > 0) {
                var nid = $('.node_id').val();
                var path = '/json/chairman/' + nid + '/';
                $.get(path, function(data) {
                    $.each(data, function(key, value) {
                        var url = value.view_node;
                        var name = value.title;
                        var text = value.field_fellow_position;
                        var img = value.field_fellow_img;
                        var body = value.field_body;
                        var output = '<div class="fellow-card"><div class="hover-content"><a href="' + url + '" tabindex="0">Learn more</a><div class="hover-img"> <img src="' + img + '" alt="Larry Diamond Hoover Headshot" loading="lazy" typeof="Image"></div><div class="detail-content"><h4>' + name + '</h4><span>' + text + '</span><p>' + body + '</p></div></div></div>';
                        $('.fellows-team-slider.with-left-img .fellow-card-wrapper').append(output);
                    });
                }).done(function(){
                    initFellowSlider();
                });
            }
            

        });
        function initFellowSlider() {
            $(".fellows-team-slider .fellow-card-wrapper").css({
                "opacity": "1",
                "overflow": "visible"
            });
            $('.fellows-team-slider .fellow-card-wrapper .fellow-card').matchHeight();
            if ($('.fellows-team-slider .fellow-card-wrapper.slick-initialized').length > 0) {
                $(".fellows-team-slider .fellow-card-wrapper").css({
                    "height": "auto",
                    "overflow": "visible"
                });
            }
            if ($('body .fellows-team-slider.with-left-img .fellow-card-wrapper .fellow-card').length > 2) {
                $('.fellows-team-slider.with-left-img').each(function() {
                    $(this).find('.fellow-card-wrapper').not('.slick-initialized').slick({
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: true,
                        infinite: false,
                        cssEase: 'linear',
                        // adaptiveHeight: true,
                        responsive: [{
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    draggable: true
                                }
                            }
                        ]
                    });
                });
            }
        }
        $(window).on("load", function() {
            initFellowSlider();
        });
    });
})(jQuery);